/** @format */
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import { getProductFacetsQueryKey } from '@toucan/common/services/search/product/query-keys';
import { fetchProductFacets } from '@toucan/common/services/search/product/requests';
import { Query } from '@toucan/common/services/search/types';

import { Milliseconds } from '@toucan/client/global/application';
import { MarketContext } from '@toucan/client/global/market';

import { UseProductFacetsReturn } from './types';

export const useProductFacets = (
    baseQuery: Partial<Query>
): UseProductFacetsReturn => {
    const { activeMarket } = useContext(MarketContext);

    // eslint-disable-next-line @tanstack/query/exhaustive-deps -- Legacy code: do not use as an example.
    const { data, isFetched } = useQuery({
        queryKey: getProductFacetsQueryKey(baseQuery),
        queryFn: () => fetchProductFacets(baseQuery, activeMarket),
        retry: false,
        refetchOnWindowFocus: false,
        staleTime: Milliseconds.FIVE_MINUTES,
    });

    return {
        facets: data?.facets ?? [],
        totalInitialResults: data?.totalResults ?? 0,
        isFetched,
    };
};
